import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { motion } from "framer-motion";
import { SectionHeading } from "components/misc/Headings.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { useNavigate } from "react-router-dom"; // For navigation

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const Row = tw.div`flex flex-col lg:flex-row -mb-10`;
const Heading = tw(SectionHeading)`text-left`;

const PopularPostsContainer = tw.div`lg:w-2/3`;
const PostsContainer = tw.div`mt-12 flex flex-col sm:flex-row sm:justify-between lg:justify-start`;
const Post = tw(motion.div)`block sm:max-w-sm cursor-pointer mb-16 last:mb-0 sm:mb-0 sm:odd:mr-8 lg:mr-8 xl:mr-16`;
const Image = styled(motion.div)((props) => [
  `background-image: url("${props.$imageSrc}");`,
  tw`h-64 bg-cover bg-center rounded`,
]);
const Title = tw.h5`mt-6 text-xl font-bold transition duration-300 group-hover:text-[#0049AC]`;
const Description = tw.p`mt-2 font-medium text-secondary-100 leading-loose text-sm`;
const AuthorInfo = tw.div`mt-6 flex items-center`;
const AuthorImage = tw.img`w-12 h-12 rounded-full`;
const AuthorNameAndProfession = tw.div`ml-4`;
const AuthorName = tw.h6`font-semibold text-lg`;
const AuthorProfile = tw.p`text-secondary-100 text-sm`;

const RecentPostsContainer = styled.div`
  ${tw`mt-24 lg:mt-0 lg:w-1/3`}
  ${PostsContainer} {
    ${tw`flex flex-wrap lg:flex-col`}
  }
  ${Post} {
    ${tw`flex justify-between mb-10 max-w-none w-full sm:w-1/2 lg:w-auto sm:odd:pr-12 lg:odd:pr-0 mr-0`}
  }
  ${Title} {
    ${tw`text-base xl:text-lg mt-0 mr-4 lg:max-w-xs`}
  }
  ${AuthorName} {
    ${tw`mt-3 text-sm text-secondary-100 font-normal leading-none`}
  }
  ${Image} {
    ${tw`h-20 w-20 flex-shrink-0`}
  }
`;
const PostTextContainer = tw.div``;

export default () => {
  const navigate = useNavigate();
  const [popularPosts, setPopularPosts] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);

  // Realistic fallback data
  const fallbackPopularPosts = [
    {
      "blog_id": 1,
      "blog_title": "10 Must-Visit Destinations in South America",
      "author_name": "Liam Carter",
      "blog_thumbnail": "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=200",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    },
    {
      "blog_id": 2,
      "blog_title": "A Gublog_ide to Exploring the Hblog_idden Gems of Southeast Asia",
      "author_name": "Sophia Anderson",
      "blog_thumbnail": "https://images.pexels.com/photos/1008155/pexels-photo-1008155.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    }
  ]


  const fallbackRecentPosts = [
    {
      "blog_id": 1,
      "blog_title": "10 Must-Visit Destinations in South America",
      "author_name": "Liam Carter",
      "blog_thumbnail": "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=200",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    },
    {
      "blog_id": 2,
      "blog_title": "A Gublog_ide to Exploring the Hblog_idden Gems of Southeast Asia",
      "author_name": "Sophia Anderson",
      "blog_thumbnail": "https://images.pexels.com/photos/1008155/pexels-photo-1008155.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    },
    {
      "blog_id": 3,
      "blog_title": "Top 7 Adventures to Try in New Zealand",
      "author_name": "Olivia Johnson",
      "blog_thumbnail": "https://images.pexels.com/photos/2245436/pexels-photo-2245436.png?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    },
    {
      "blog_id": 4,
      "blog_title": "Budget-Friendly European Cities You Can’t Miss",
      "author_name": "Ethan Davis",
      "blog_thumbnail": "https://images.pexels.com/photos/1271619/pexels-photo-1271619.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    },
    {
      "blog_id": 5,
      "blog_title": "The Best Beaches for a Relaxing Vacation",
      "author_name": "Emma Taylor",
      "blog_thumbnail": "https://images.pexels.com/photos/1285625/pexels-photo-1285625.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "blog_description": "The Best Beaches for a Relaxing Vacation"
    }
  ]


  useEffect(() => {

    const fetchRecentBlogs = async () => {
      try {

        const response = await fetch(`${API_URL}/web/blogs/recent-blogs`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          const blogData = result.data;
          setRecentPosts(blogData)
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchRecentBlogs();


    const fetchPopularBlogs = async () => {
      try {

        const response = await fetch(`${API_URL}/web/blogs/popular-blogs`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          const blogData = result.data;
          setPopularPosts(blogData)
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchPopularBlogs();

  }, []);

  return (
    <Container>
      <ContentWithPaddingXl>
        <Row>
          <PopularPostsContainer>
            <Heading>Popular Blogs</Heading>
            <PostsContainer>
              {popularPosts.map((post) => (
                <Post
                  key={post.blog_id}
                  className="group"
                  onClick={() => navigate(`/pg/blogs/${post.blog_id}/read?blogTitle=${post.blog_title}`)}
                  initial="rest"
                  whileHover="hover"
                  animate="rest"
                >
                  <Image
                    transition={{ duration: 0.3 }}
                    $imageSrc={post.blog_thumbnail}
                  />
                  <Title>{post.blog_title}</Title>
                  <Description>{(post.blog_description).split(/\s+/).slice(0, 20).join(' ') + "..Read more"}</Description>
                  <AuthorInfo>
                    <AuthorImage
                      src={
                        post.author_pic ||
                        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                      }
                    />
                    <AuthorNameAndProfession>
                      <AuthorName>{post.author_name}</AuthorName>
                      <AuthorProfile>{post.author_designation}</AuthorProfile>
                    </AuthorNameAndProfession>
                  </AuthorInfo>
                </Post>
              ))}
            </PostsContainer>
          </PopularPostsContainer>
          <RecentPostsContainer>
            <Heading>Recent Posts</Heading>
            <PostsContainer>
              {recentPosts.map((post) => (
                <Post
                  key={post.blog_id}
                  className="group"
                  onClick={() => navigate(`/pg/blogs/${post.blog_id}/read?blogTitle=${post.blog_title}`)}
                >
                  <PostTextContainer>
                    <Title>{post.blog_title}</Title>
                    <AuthorName>{post.author_name}</AuthorName>
                  </PostTextContainer>
                  <Image $imageSrc={post.blog_thumbnail} />
                </Post>
              ))}
            </PostsContainer>
          </RecentPostsContainer>
        </Row>
      </ContentWithPaddingXl>
    </Container>
  );
};
